import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

function startOfWeek(d) { const x = new Date(d); const day = x.getDay(); x.setDate(x.getDate() - day); x.setHours(0,0,0,0); return x; }
function fmt(d) { return d.toISOString().slice(0,10); }

export default function AdminCalendar() {
  const [start, setStart] = useState(startOfWeek(new Date()));
  const [items, setItems] = useState([]);

  useEffect(() => {
    const end = new Date(start); end.setDate(end.getDate()+6);
    api.get(`/calendar?start=${fmt(start)}&end=${fmt(end)}`).then(r=>setItems(r.data)).catch(()=>{});
  }, [start]);

  const days = Array.from({length:7}, (_,i)=>{ const d = new Date(start); d.setDate(d.getDate()+i); return d; });
  const byDay = (d) => items.filter(b => b.travel_date === fmt(d));

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-display font-black tracking-tight">Booking Calendar</h1>
        <div className="flex gap-2">
          <button onClick={()=>{const s=new Date(start); s.setDate(s.getDate()-7); setStart(s);}} className="px-3 py-2 rounded-md bg-white border border-slate-300 text-sm font-semibold" data-testid="cal-prev">← Prev</button>
          <button onClick={()=>setStart(startOfWeek(new Date()))} className="px-3 py-2 rounded-md bg-white border border-slate-300 text-sm font-semibold" data-testid="cal-today">Today</button>
          <button onClick={()=>{const s=new Date(start); s.setDate(s.getDate()+7); setStart(s);}} className="px-3 py-2 rounded-md bg-white border border-slate-300 text-sm font-semibold" data-testid="cal-next">Next →</button>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-7 gap-3">
        {days.map((d,i) => (
          <div key={i} className="min-h-[200px] p-3 rounded-xl bg-white border border-slate-200" data-testid={`cal-day-${fmt(d)}`}>
            <div className="text-xs font-semibold text-slate-500">{d.toLocaleDateString(undefined,{weekday:'short'}).toUpperCase()}</div>
            <div className="text-xl font-display font-black text-[#1e1b4b]">{d.getDate()}</div>
            <div className="mt-2 space-y-1.5">
              {byDay(d).map(b => (
                <div key={b.booking_id} className="p-2 rounded-md bg-[#1e1b4b]/5 border border-[#1e1b4b]/10 text-xs">
                  <div className="font-semibold text-[#1e1b4b] truncate">{b.customer_name}</div>
                  <div className="text-slate-500 truncate">{b.from_place} → {b.to_place}</div>
                  <div className="text-[10px] text-slate-500">{b.departure_time || "—"} · {b.passengers} pax</div>
                </div>
              ))}
              {byDay(d).length===0 && <div className="text-xs text-slate-400">No bookings</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
